import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'
import AttributeLog from '@/views/Project/Observation/components/attributeLog/attributeLog.vue'

import { observationIcons, statusColor, severityColor, priorityColor } from '@/types/observation'
import LocationDrawing from '@/views/Project/Observation/components/locationDrawing.vue'

@Component({
    inheritAttrs: false,
    name: 'log-observation',
    components: { LogTemplate, AttributeLog, LocationDrawing },
})
export default class LogObservation extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    observationIcons = observationIcons
    statusColor = statusColor
    severityColor = severityColor
    priorityColor = priorityColor

    get customString() {
        switch (this.log.logEventName) {
            case 'observationLocationDrawingUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }_${this.log.payload['old'] ? 'isTrue(old)' : 'isFalse(old)'}`
            case 'observationPublished':
                return `${this.log.logEventName}_${
                    this.log.payload['anonymous'] ? 'isTrue(anonymous)' : 'isFalse(anonymous)'
                }`
            case 'observationTitleUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationArchivedUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'observationAttachmentHiddenUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'observationActionTakenUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationResultUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationHappenedAtUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationCoordinatesUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new']['latitude'] && this.log.payload['new']['longitude']
                        ? 'notNull(new)'
                        : 'isNull(new)'
                }`
            case 'observationPriorityUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationSeverityUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationCostUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationArchivedUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'observationDueWarningUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationDueUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationHasExtendedVisibilityUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'observationCategoryUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationCauseUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationLocationUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationResponsibleUserUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationResponsibleLeaderUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationMainAttachmentUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationAttachmentDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationMainAttachmentUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'observationAttachmentHiddenUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            default:
                return this.log.logEventName
        }
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null

    formatLocationDrawingData(payload) {
        return {
            locationDrawingX: payload.x,
            locationDrawingY: payload.y,
            locationDrawing: {
                data: {
                    name: payload.drawing.name,
                    fileId: payload.drawing.fileId,
                },
            },
        }
    }

    async created() {
        switch (this.log.logEventName) {
            case 'observationCreated':
                if (this.log.payload.describtion) {
                    this.editorJS = {
                        newVal: this.log.payload.describtion,
                        oldVal: null,
                    }
                }
                break
            case 'observationDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'observationActionTakenUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'observationResultUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'observationMainAttachmentUpdated':
                this.newAttachment = this.log.new
                    ? {
                          fileId: this.log.new.fileId,
                          filename: this.log.new.filename,
                      }
                    : null
                this.oldAttachment = this.log.old
                    ? {
                          fileId: this.log.old.fileId,
                          filename: this.log.old.filename,
                      }
                    : null
                break

            case 'observationAttachmentDescriptionUpdated':
                this.attachment = this.log.payload
                    ? {
                          fileId: this.log.payload.fileId,
                          filename: this.log.payload.filename,
                      }
                    : null
                this.editorJS = {
                    newVal: this.log.new,
                    oldVal: this.log.old,
                }
                break

            case 'observationAttachmentFileIdUpdated':
                this.newAttachment = this.log.new
                    ? {
                          fileId: this.log.new.fileId,
                          filename: this.log.new.filename,
                      }
                    : null

                this.oldAttachment = this.log.old
                    ? {
                          fileId: this.log.old.fileId,
                          filename: this.log.old.filename,
                      }
                    : null
                break

            case 'observationAttachmentHiddenUpdated':
                this.attachment = this.log.payload
                    ? {
                          fileId: this.log.payload.fileId,
                          filename: this.log.payload.filename,
                      }
                    : null
                break

            case 'observationAttachmentCreated':
                this.attachment = this.log.payload
                    ? {
                          fileId: this.log.payload.fileId,
                          filename: this.log.payload.filename,
                      }
                    : null
                break
        }
    }
}
